import { Address, LogisticScheduledTaskAddress } from "../../types/server";

export function addressToScheduledAddress(
  address?: Address
): LogisticScheduledTaskAddress {
  if (!address) {
    return undefined;
  }

  return {
    id: address.id,
    address_text: address.address,
  };
}
